import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/config/siteConfig";
import { Reveal, SectionHeading } from "@/components/Reveal";

export const Testimonials = () => (
  <section className="bg-warm py-16 sm:py-24 lg:py-28" data-testid="testimonials-section">
    <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        center
        label="Testimonials"
        title="What Our Clients Say"
        subtitle="Real experiences from real customers."
      />

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.1}>
            <figure
              className="bg-white rounded-xl border border-line p-8 h-full border-dashed"
              data-testid={`testimonial-card-${t.id}`}
            >
              <Quote size={26} className="text-gold/70" />
              <blockquote className="mt-5 font-display text-lg italic text-ink/70 leading-relaxed">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-6 text-[12px] uppercase tracking-[0.16em] text-ink-soft/70">
                Verified client review · coming soon
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
